import React from 'react';
import './PlatformSitePriceModal.css';

interface PlatformSitePriceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  serviceName: string;
  loading?: boolean;
}

const PlatformSitePriceModal: React.FC<PlatformSitePriceModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  serviceName,
  loading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="platform-site-price-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>🏛️ Platform Site Selection</h3>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="modal-content">
          <div className="service-info">
            <h4>{serviceName}</h4>
            <p className="service-location">📍 Antaryatra Sacred Temple Site, Varanasi</p>
          </div>

          <div className="confirmation-message">
            <p>🌟 Platform site pricing has been updated. Please check the revised plan prices and confirm to continue.</p>
          </div>

          <div className="platform-benefits">
            <h5>🌟 Platform Site Benefits:</h5>
            <ul>
              <li>Sacred consecrated environment</li>
              <li>Proper planetary alignments</li>
              <li>Energized yantras and sacred spaces</li>
              <li>Traditional temple atmosphere</li>
              <li>Enhanced spiritual efficacy</li>
            </ul>
          </div>

          <div className="modal-actions">
            <button 
              className="cancel-button" 
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              className="confirm-button" 
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? 'Processing...' : 'Confirm & Continue'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformSitePriceModal;